import request from '@/utils/request'

const api = {
    bindThingNo: "/work/bindThingNo",
    checkThingNoBind: "/work/checkThingNoBind",
}
export default api

export function bindThingNo(data){
    return request({
        url: api.bindThingNo,
        method: 'post',
        data
    })
}

export function checkThingNoBind(data){
    return request({
        url: api.checkThingNoBind,
        method: 'post',
        data
    })
}